<template>
<div class="organization content">
        <div class="organization_box">
            <Table :loading="loading" border ref="selection" :columns="columns" :data="organizationList"></Table>
        </div>
        <Modal
                v-model="isCourse"
                title="查看课程">
            <div>
                <p v-for="item in courseInfo" v-if="courseInfo">{{item.name}}</p>
                <p v-if="courseInfo.length==0">暂无课程</p>
            </div>
            <div slot="footer">
                <Button  type="primary" size="large" @click="ok">关闭</Button>
            </div>
         </Modal>
    </div>
</template>
<style scoped>
.organization_box {
    margin-top: 20px;
}
</style>
<script>
    import Http from '../../../libs/http.js'
    export default {
        data() {
            return {
                organizationList:[],
                loading:false,
                isCourse:false,
                courseInfo:'',
                columns:[
                    {
                        title: 'No.',
                        type: 'index',
                    },
                    {
                        title:'机构名称',
                        key:'name',
                    },
                    {
                        title:'备注',
                        key:'memo',
                        render:(h,params) => {
                            return h("span", params.row.memo ? params.row.memo : '暂无');
                        }
                    },
                    {
                        title: '操作',
                        key: 'action',
                        align: 'center',
                        render: (h, params) => {
                            return h('div', [
                                h('Button', {
                                    props: {
                                        type: 'success',
                                        size: 'small'
                                    },
                                    style: {
                                        marginRight: '10px'
                                    },
                                    on: {
                                        click: () => {
                                            this.getCourse(params.row.gardenId)
                                        }
                                    }
                                }, '查看课程'),
                                h('Button', {
                                    props: {
                                        type: 'primary',
                                        size: 'small'
                                    },
                                    style: {
                                        marginRight: '10px'
                                    },
                                    on: {
                                        click: () => {
                                            this.look(params.row)
                                        }
                                    }
                                }, '老师管理'),
                            ]);
                        }
                    }
                ]
            }
        },
        created() {
            this.getList()
        },
        methods: {
            //获取机构列表
            getList() {
                var _this = this
                Http.post('/custom/madyGarden/opt',{
                    opt:1
                }).then(res=>{
                    if(res) {
                        _this.organizationList = res
                    }
                })
            },
            //老师管理
            look(row) {
                var _this = this
                if (row) {
                    _this.$router.push({ path: 'userInfo', query: {gardenId:row.gardenId,name:row.name} })
                }
            },
            //查看课程
            getCourse(id) {
                var _this = this
                Http.post('/custom/madyGarden/opt',{
                    opt:3,
                    gardenId:id
                }).then(res=>{
                    if(res) {
                        _this.courseInfo = res
                    }
                    _this.isCourse = true
                })

            },
            ok() {
                this.isCourse = false
            },
        }
    }
</script>
